import Markdown from 'markdown-to-jsx'
import { Button as AriaButton } from 'react-aria-components'
import { useTranslation } from 'react-i18next'
import IcOutlineHelpOutline from '~icons/ic/outline-help-outline'
import { UITooltipResponsive } from 'src/components/HelpIcon'
import Text from 'src/components/ui/Text'
import { cx } from 'src/utils/cx'

function intlFormatNum(num: number) {
  return new Intl.NumberFormat().format(num)
}

export function CreditBonusExplanationHelp(props: StyleProps) {
  const { t } = useTranslation(['membership'])

  const trigger = (open?: () => void) => (
    <AriaButton
      onPress={open}
      className={cx('flex items-center gap-1', props.className)}
    >
      <IcOutlineHelpOutline className={cx('size-4')} />
      <span>
        <Text i18nKey="membership:more-credits.bonus-help.label" />
      </span>
    </AriaButton>
  )

  return (
    <UITooltipResponsive trigger={trigger} variant="normal">
      <div className="max-w-[400px]">
        <hgroup>
          <p className="text-sm text-neutral-400">
            <Text i18nKey="membership:more-credits.bonus-help.base-amount" />
          </p>
          <p>
            {intlFormatNum(100000)}
            <small className="pl-1">
              (<Text i18nKey="membership:more-credits.bonus-help.example" />)
            </small>
          </p>
        </hgroup>
        <table className="mt-4 mb-1 [&_td:first-child]:text-neutral-500 [&_td:first-child]:pl-3 [&_td:first-child]:pr-12 [&_td:last-child]:text-right  [&_td:last-child]:pl-4 [&_td:last-child]:pr-3 [&_td:nth-child(2)]:text-right [&_td:nth-child(2)]:text-blue-500 [&_td]:py-1 [&_td]:px-1 w-full">
          <tbody>
            <tr>
              <td>
                <Text i18nKey="membership:membership.label" />
              </td>
              <td>+100%</td>
              <td>{intlFormatNum(100000)}</td>
            </tr>
            <tr>
              <td>
                <Text i18nKey="membership:more-credits.bonus-help.first-deposit" />
              </td>
              <td>+100%</td>
              <td>{intlFormatNum(100000)}</td>
            </tr>
            <tr className="[&>td]:pb-2">
              <td>
                <Text i18nKey="membership:more-credits.bonus-help.promo-bonus" />
              </td>
              <td>+20%</td>
              <td>{intlFormatNum(20000)}</td>
            </tr>
            <tr className="[&>td]:pt-2 border-t">
              <td>
                <Text i18nKey="membership:more-credits.bonus-help.total-bonus" />
              </td>
              <td className="font-semibold">+220%</td>
              <td className="font-semibold">{intlFormatNum(220000)}</td>
            </tr>
          </tbody>
        </table>
        <div className="bg-sky-100 rounded-lg flex items-center justify-between px-3 py-1 mb-4">
          <span>
            <Text i18nKey="membership:more-credits.bonus-help.final-amount" />
          </span>
          <span className="font-semibold text-blue-500">
            {intlFormatNum(320000)}
          </span>
        </div>

        <Markdown
          options={{
            forceBlock: true,
            overrides: {
              a: (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="no-underline text-violet-600 dark:text-violet-400"
                />
              ),
            },
          }}
          className="text-sm text-neutral-400"
        >
          {t('membership:more-credits.bonus-help.footnote')}
        </Markdown>
      </div>
    </UITooltipResponsive>
  )
}
